// extracted by mini-css-extract-plugin
module.exports = {"text-center":"newslettersignup_text-center__Gsl7j","container":"newslettersignup_container__ri0aF","input":"newslettersignup_input__Aiu8N"};